export enum LegacyFormTplEnum {
  MembershipInvoice = 3,
  OneDollarInvoice = 303,
  ConciergeInvoice = 353,
  ConciergeTermsReceipt = 354,
  ConciergeAdditionalInvoice = 363,
  ConciergeAdditionalTermsReceipt = 364,
}
